import { render, staticRenderFns } from "./UserDependentTextEdit.vue?vue&type=template&id=22770568&"
import script from "./UserDependentTextEdit.vue?vue&type=script&lang=js&"
export * from "./UserDependentTextEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports